import { useState } from 'react';

export type StatusPillType = 'idle' | 'working' | 'ready' | 'error';

export function useGlobalStatus() {
  const [status, setStatus] = useState<StatusPillType>('idle');
  const [statusMessage, setStatusMessage] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const resetStatus = () => {
    setStatus('idle');
    setStatusMessage('');
    setIsSaving(false);
  };

  return {
    status, setStatus,
    statusMessage, setStatusMessage,
    isSaving, setIsSaving,
    resetStatus
  };
}
